/**
 * 缓存说明:实时值缓存
 */
import vm from './storeTools.js'
import realApi from '../components/api/realApi.js'

var basestate = {
	mapkey: "",
	keyList: [],
	needRefresh: false, //用于添加后立刻刷新,有一定延时以免大量修改的时候调太多次,
	waitForgetText: [], //等待获取文字的数组
	hadGetText: [], //已经尝试获取过的
	keyToValue: {}, //数值
	keyToTime: {}, //时间
	keyToDeviceState: {}, //设备状态
	keyValueToText: {
		//变量获取实时值以后,应该显示的文字,格式是通信变量名_值(没有小数点)对应到文字信息
	},
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		ids(state, getters) {
			state.mapkey = ""
			return state.keyList.join(',')
		},
		getValue(state, getters) {
			//获取指定变量的实时值
			return keys => {
				var list = []
				for (var i = 0, len = keys.length; i < len; i++) {
					var e = keys[i]
					var value = state.keyToValue[e]
					if (!isempty(value)) {
						value = cutDigital(value)
					}
					list.push(value)
				}
				return list
			}
		},
		getDeviceState(state, getters) {
			return keys => {
				var result = {}
				for (var i = 0, len = keys.length; i < len; i++) {
					var e = keys[i]
					var value = state.keyToDeviceState[e]
					if (!state.keyToDeviceState.hasOwnProperty('devicestate.'+e)) {
						result[e]=-1
					}else{
						result[e]=state.keyToDeviceState['devicestate.'+e]
					}
				}
				return result
			}
		},
		getTime(state, getters) {
			return keys => {
				var list = []
				for (var i = 0, len = keys.length; i < len; i++) {
					list.push(state.keyToTime[keys[i]])
				}
				return list
			}
		},
		getText(state, getters) {
			return (id, value) => {
				try {
					var temp = state.keyValueToText[id]
					if (isempty(temp)) {
						//等待获取真正的数据
						if (state.waitForgetText.indexOf(id) == -1 && state.hadGetText.indexOf(id) == -1) {
							state.waitForgetText.push(id)
							state.hadGetText.push(id)
						}
						//值为当前值
						return value
					}
					var key = id + "_" + parseInt(value)
					if (isempty(temp[key])) {
						return value
					}
					return temp[key]
				} catch (e) {
					err(e)
				}
				return value
			}
		},
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		refreshRealTimeValue(state) {
			//刷新数据
			if (isempty(store.getters.ids)) {
				return
			}
			if (isempty(state.mapkey)) {
				realApi.getMACRealValueWithID(store.getters.ids, "", respon => {
					store.commit("setData", {
						list: state.keyList,
						data: respon
					})
				})
			} else {
				realApi.getMACRealValueWithIDByMapkey(state.mapkey, "", respon => {
					store.commit("setData", {
						list: state.keyList,
						data: respon
					})
				})
			}
		},
		setData(state, params) {
			var data = params.data
			var list = params.list
			var mapkey = data.mapkey
			data = data.data
			if (!isempty(mapkey)) {
				state.mapkey = mapkey
			}
			var datapoor = data.split(";")
			for (var i = 0, len = list.length; i < len; i++) {
				var e = list[i]
				var value = datapoor[i]
				if (!isempty(value)) {
					var vl = value.split(":")
					//保存数值
					vm.Vue.set(state.keyToValue, e, vl[0])
					//保存时间
					vm.Vue.set(state.keyToTime, e, vl[1])
					if (e.startsWith('devicestate.')) {
						vm.Vue.set(state.keyToDeviceState,e,parseInt(vl[0]))
					}
				}
			}
		},
		addKeys(state, keys) {
			//添加一组需要获取实时值的变量,同时将这些设备的设备状态获取一下
			var deviceName = {}
			for (var i = 0, len = keys.length; i < len; i++) {
				var k = keys[i]
				if (state.keyList.indexOf(k) == -1) {
					deviceName['devicestate.' + k.substring(0, k.indexOf('.'))] = '1'
					state.keyList.push(k)
				}
			}
			var dk = Object.keys(deviceName)
			for (var i = 0, len = dk.length; i < len; i++) {
				var item = dk[i]
				if (state.keyList.indexOf(item) == -1) {
					state.keyList.push(item)
				}
			}
			state.needRefresh = true
		},
		removeKeys(state, keys) {
			//移除一组变量
			var nowList = state.keyList.filter(e => {
				return keys.indexOf(e) == -1
			})
			//刷新一下所有需要获取状态的设备
			var allDeviceNameCount = {}
			for (var i = 0, len = nowList.length; i < len; i++) {
				var item = nowList[i]
				if (item.startsWith('devicestate.')) {
					if (!allDeviceNameCount.hasOwnProperty(item)) {
						allDeviceNameCount[item] = 0
					}
				} else {
					var deviceName = 'devicestate.'+item.substring(0, item.indexOf('.'))
					if (!allDeviceNameCount.hasOwnProperty(deviceName)) {
						allDeviceNameCount[deviceName] = 1
					}else{
						allDeviceNameCount[deviceName] += 1
					}
				}
			}
			nowList = nowList.filter(item=>!item.startsWith('devicestate.') || allDeviceNameCount[item]>0)
			vm.Vue.set(state, 'keyList', nowList)
		},
		getLimitMap(state) {
			var ids = ""
			state.waitForgetText.forEach(e => {
				ids += e + ","
			})
			vm.Vue.set(state, "waitForgetText", [])
			ids = ids.substr(0, ids.length - 1)
			realApi.getLimitMap(ids, respon => {
				var nowtext = state.keyValueToText
				var keys = Object.keys(respon)
				keys.forEach(e => {
					vm.Vue.set(state.keyValueToText, e, respon[e])
				})
			})
		}
	}
});
//数据的刷新频率
addNewTask("refreshRealTimeValue", 0, 3000, -1, function() {
	store.commit("refreshRealTimeValue")
})
//每次有变动就刷新一下
addNewTask("refreshRealTimeValueRightNow", 0, 1000, -1, function() {
	if (store.state.needRefresh) {
		store.commit("refreshRealTimeValue")
		store.state.needRefresh = false
	}
	if (store.state.waitForgetText.length > 0) {
		store.commit("getLimitMap")
	}
})

//对外提供
export default store
